import { TAB } from './tab.enum'

import miguelaImg2x from 'assets/images/vector-profile-img/miguela.png'
import richardImg2x from 'assets/images/vector-profile-img/richard.png'
import dara2x from 'assets/images/vector-profile-img/dara.png'
import seyrahImg2x from 'assets/images/vector-profile-img/seyrah.png'
import jamjamImg2x from 'assets/images/vector-profile-img/jamjam.png'
import iceyImg2x from 'assets/images/vector-profile-img/icey.png'
import ririImg2x from 'assets/images/vector-profile-img/riri.png'
import phewImg2x from 'assets/images/vector-profile-img/phew.png'
import silhouetteImg2x from 'assets/images/vector-profile-img/silhouette.png'
import matt2x from 'assets/images/vector-profile-img/matt.png'
import yudi2x from 'assets/images/vector-profile-img/yudi.png'
import dhimas2x from 'assets/images/vector-profile-img/dhimas.png'
import chris2x from 'assets/images/vector-profile-img/chris.png'
import charles2x from 'assets/images/vector-profile-img/charles.png'
import gii2x from 'assets/images/vector-profile-img/gii.png'
import fajar2x from 'assets/images/vector-profile-img/fajar.png'

import miguelaImg4x from 'assets/images/vector-profile-img/miguela4x.png'
import richardImg4x from 'assets/images/vector-profile-img/richard4x.png'
import dara4x from 'assets/images/vector-profile-img/dara4x.png'
import seyrahImg4x from 'assets/images/vector-profile-img/seyrah4x.png'
import jamjamImg4x from 'assets/images/vector-profile-img/jamjam4x.png'
import iceyImg4x from 'assets/images/vector-profile-img/icey4x.png'
import ririImg4x from 'assets/images/vector-profile-img/riri4x.png'
import phewImg4x from 'assets/images/vector-profile-img/phew4x.png'
import silhouetteImg4x from 'assets/images/vector-profile-img/silhouette4x.png'
import matt4x from 'assets/images/vector-profile-img/matt4x.png'
import yudi4x from 'assets/images/vector-profile-img/yudi4x.png'
import dhimas4x from 'assets/images/vector-profile-img/dhimas4x.png'
import chris4x from 'assets/images/vector-profile-img/chris4x.png'
import charles4x from 'assets/images/vector-profile-img/charles4x.png'
import gii4x from 'assets/images/vector-profile-img/gii4x.png'
import fajar4x from 'assets/images/vector-profile-img/fajar4x.png'

import { ReactComponent as FbSvg } from 'assets/svg/icons/socials/filled/fb.svg'
import { ReactComponent as IgSvg } from 'assets/svg/icons/socials/filled/ig.svg'
import { ReactComponent as TwSvg } from 'assets/svg/icons/socials/filled/tw.svg'
import { ReactComponent as YtSvg } from 'assets/svg/icons/socials/filled/yt.svg'

export interface SocialMedia {
  twitter?: string
  instagram?: string
  facebook?: string
  youtube?: string
  logo: any
}

export interface Team {
  nameLong: string
  nameShort: string
  position: TAB
  role: string
  description: string
  img?: any
  img4x?: any
  ign?: string
  joinedDate?: string
  games?: string
  socmed?: any
}

export const TEAMS = [
  {
    nameLong: 'Sarah Nesperos',
    nameShort: 'Sarah Nesperos',
    ign: 'Seyrah',
    joinedDate: 'October 11, 2021',
    games: 'Axie Infinity and Mobile Legends',
    position: TAB.CONTENT_CREATORS,
    role: 'Streamer',
    description: 'Nothing can go wrong when you have pink hair',
    socmed: [
      {
        facebook: '421k',
        logo: FbSvg,
        link: 'https://www.facebook.com/Seyrahxx'
      },
      {
        tiktok: '106.8k',
        logo: YtSvg,
        link: 'https://www.tiktok.com/@seyrahx'
      },
      {
        instagram: '11.4k',
        logo: IgSvg,
        link: 'https://www.instagram.com/seyrahxx/'
      }
    ],
    img: seyrahImg2x,
    img4x: seyrahImg4x
  },
  {
    nameLong: 'Dara Belmonte',
    nameShort: 'Dara Belmonte',
    ign: 'Dara',
    joinedDate: 'October 27, 2021',
    games: 'Axie Infinity and Valorant',
    position: TAB.CONTENT_CREATORS,
    role: 'Streamer',
    description: 'Im a happy person , I always smile when I stream',
    socmed: [
      {
        facebook: '363k',
        logo: FbSvg,
        link: 'https://www.facebook.com/Darabelmonte04'
      },
      {
        youtube: '75.6k',
        logo: YtSvg,
        link: 'https://www.youtube.com/c/DaraBelmonte'
      }
    ],
    img: dara2x,
    img4x: dara4x
  },
  // {
  //   nameLong: 'Missy Gaming',
  //   nameShort: 'Missy Gaming',
  //   ign: 'Missy',
  //   joinedDate: 'November, 2021',
  //   games: 'Axie Infinity, Genshin Impact, MObile Legends, Thetan Arena, CODM etc',
  //   position: TAB.CONTENT_CREATORS,
  //   role: 'Streamer',
  //   description: 'I love games,I played for fun and to meet other people.',
  //   socmed: [
  //     {
  //       facebook: '482k',
  //       logo: FbSvg,
  //       link: 'https://www.facebook.com/missyGaming09'
  //     },
  //     {
  //       tiktok: '325.1k',
  //       logo: YtSvg,
  //       link: 'https://www.tiktok.com/@misszaigaming'
  //     }
  //   ],
  //   img: silhouetteImg2x,
  //   img4x: silhouetteImg4x
  // },
  {
    nameLong: 'Mary Razan Vallesteros',
    nameShort: 'Mary Razan V.',
    ign: 'Icey',
    joinedDate: 'October, 2021',
    games: 'board games, Axie Infinity and Mobile Legends',
    position: TAB.CONTENT_CREATORS,
    role: 'Streamer',
    description: 'I am a perfect combination of danger and charm',
    socmed: [
      {
        facebook: '471k',
        logo: FbSvg,
        link: 'https://www.facebook.com/iceyvallesteros'
      },
      {
        youtube: '4.1k',
        logo: YtSvg,
        link: 'https://www.youtube.com/c/Iceyvallesteros'
      },
      {
        instagram: '2k',
        logo: IgSvg,
        link: 'https://www.instagram.com/iceyvallesteros/'
      }
    ],
    img: iceyImg2x,
    img4x: iceyImg4x
  },
  {
    nameLong: 'Princess Miguela',
    nameShort: 'Princess Miguela',
    ign: 'Aphrodite',
    joinedDate: '27 October, 2021',
    games: 'Axie, Valorant, ML',
    position: TAB.CONTENT_CREATORS,
    role: 'Streamer',
    description: 'Bubbly and talkative girl who loves being herself, and always wants to spread positive vibes',
    socmed: [
      {
        tiktok: '450.5k',
        logo: TwSvg,
        link: 'https://www.tiktok.com/@princesscmiguela?'
      },
      {
        facebook: '14k',
        logo: FbSvg,
        link: 'https://www.facebook.com/AphroditeML'
      },
      {
        instagram: '3k',
        logo: IgSvg,
        link: 'https://www.instagram.com/princessmiguela/'
      }
    ],
    img: miguelaImg2x,
    img4x: miguelaImg4x
  },
  {
    nameLong: 'Jamila San Agustin',
    nameShort: 'Jamila San A.',
    ign: 'JamJam',
    joinedDate: '10 October, 2021',
    games: 'Valorant, Mobile Legends Bang Bang, CODM',
    position: TAB.CONTENT_CREATORS,
    role: 'Streamer',
    description: 'Girl Gamer, Content Creator and Artist.',
    socmed: [
      {
        facebook: '164.9k',
        logo: FbSvg,
        link: 'https://www.facebook.com/jamjamgaming/'
      },
      {
        tiktok: '4k',
        logo: YtSvg,
        link: 'https://www.tiktok.com/@iamjamjamgarcia '
      },
      {
        instagram: '1.9k',
        logo: IgSvg,
        link: 'https://www.instagram.com/jamjam.garcia/'
      }
    ],
    img: jamjamImg2x,
    img4x: jamjamImg4x
  },
  {
    nameLong: 'Rianna Jean L. Macatol',
    nameShort: 'Rianna Jean L. M.',
    ign: 'Riri',
    joinedDate: '11 October, 2021',
    games: 'valorant, ran online, axie infinity',
    position: TAB.CONTENT_CREATORS,
    role: 'Streamer',
    description: 'Aspiring architect, loves to play games, watch movies and series.',
    socmed: [
      {
        facebook: '10.3k',
        logo: FbSvg,
        link: 'https://www.facebook.com/MsRiriGaming'
      }
    ],
    img: ririImg2x,
    img4x: ririImg4x
  },
  {
    nameLong: 'Richard',
    nameShort: 'Richard',
    ign: 'Verve',
    joinedDate: 'November 2021',
    games: 'Axie, infinity, Valorant, Minecraft, League of Legends, (400+ others)',
    position: TAB.CONTENT_CREATORS,
    role: 'Streamer',
    description:
      'Just a guy trying to make people happy one stream at a time. A talkative boy who loves being himself, and always wants to spread positive vibes',
    socmed: [
      {
        facebook: '29.4k',
        logo: FbSvg,
        link: 'http://fb.gg/VerveRichard'
      }
    ],
    img: richardImg2x,
    img4x: richardImg4x
  },
  {
    nameLong: 'Angelo Kyle',
    nameShort: 'Angelo Kyle',
    ign: 'Pheww',
    joinedDate: 'November 2021',
    games: 'Axie infinity, Mobile Legend.',
    position: TAB.CONTENT_CREATORS,
    role: 'Streamer',
    description: 'Eyes on the prize, feet on the ground.',
    socmed: [
      {
        facebook: '309k',
        logo: FbSvg,
        link: 'https://web.facebook.com/phewwgamingpage'
      },
      {
        instagram: '2k',
        logo: IgSvg,
        link: 'https://www.instagram.com/phewww18/'
      }
    ],
    img: phewImg2x,
    img4x: phewImg4x
  },
  {
    nameLong: 'Jhonric Lugtu',
    nameShort: 'Jhonric Lugtu',
    ign: 'Gii',
    joinedDate: 'June 2021',
    games: 'Mobile Legends, Valorant, GTA V, DOTA 2 and Axie Infinity',
    position: TAB.CONTENT_CREATORS,
    role: 'Streamer',
    description: 'Night shift grinder and streamer. Digital art connoisseur',
    socmed: [
      {
        facebook: '772',
        logo: FbSvg,
        link: 'https://facebook.com/giilexington  '
      }
    ],
    img: gii2x,
    img4x: gii4x
  },
  {
    nameLong: 'Charles Marino',
    nameShort: 'Charles Marino',
    ign: 'Charles',
    joinedDate: 'December 2011',
    games: 'Axie Infinity, Hackerrank, CS 1.6',
    position: TAB.ENGINEERS,
    role: 'Engineer',
    description: 'Ex-Facebook NFT OG',
    socmed: [
      {
        twitter: '404',
        logo: TwSvg,
        link: '#'
      },
      {
        instagram: '404',
        logo: IgSvg,
        link: '#'
      },
      {
        youtube: '404',
        logo: YtSvg,
        link: '#'
      },
      {
        facebook: '404',
        logo: FbSvg,
        link: '#'
      }
    ],
    img: charles2x,
    img4x: charles4x
  },
  {
    nameLong: 'I Made Wahyudi',
    nameShort: 'I Made Wahyudi',
    ign: 'IMaddiXI',
    joinedDate: 'August 2021',
    games: 'CTF Cyber Security, Hack The Box',
    position: TAB.ENGINEERS,
    role: 'Engineer',
    description: '404 Life not found',
    socmed: [
      {
        github: '25',
        logo: TwSvg,
        link: 'https://github.com/yudi7ll'
      },
      {
        linkedin: '20',
        logo: YtSvg,
        link: 'https://www.linkedin.com/in/yudi7ll'
      },
      {
        instagram: '485',
        logo: IgSvg,
        link: 'https://www.instagram.com/yudi7ll'
      }
    ],
    img: yudi2x,
    img4x: yudi4x
  },
  {
    nameLong: 'Dhimas Putra Hartono',
    nameShort: 'Dhimas Putra',
    ign: 'Nathanos',
    joinedDate: '1 November 2021',
    games: 'MineSweeper',
    position: TAB.ENGINEERS,
    role: 'Designer',
    description: "hello,I'm a pure human",
    socmed: [
      {
        twitter: '404',
        logo: TwSvg,
        link: '#'
      },
      {
        instagram: '404',
        logo: IgSvg,
        link: '#'
      },
      {
        youtube: '404',
        logo: YtSvg,
        link: '#'
      },
      {
        facebook: '404',
        logo: FbSvg,
        link: '#'
      }
    ],
    img: dhimas2x,
    img4x: dhimas4x
  },
  {
    nameLong: 'Fajar Alnito Bagasnanda',
    nameShort: 'Fajar Alnito',
    ign: 'GrizzlyMg',
    joinedDate: 'August 2021',
    games: 'Genshin Impact',
    position: TAB.ENGINEERS,
    role: 'Engineer',
    description: 'I love to eat and sleep',
    socmed: [
      {
        twitter: '404',
        logo: TwSvg,
        link: '#'
      },
      {
        instagram: '404',
        logo: IgSvg,
        link: '#'
      },
      {
        facebook: '404',
        logo: FbSvg,
        link: '#'
      }
    ],
    img: fajar2x,
    img4x: fajar4x
  },
  {
    nameLong: 'Christopher Yu',
    nameShort: 'Christopher Yu',
    ign: 'ChaO',
    joinedDate: 'August 2021',
    games: 'DOTA',
    position: TAB.ENGINEERS,
    role: 'Engineer',
    description: 'I Love Javascript and IU',
    socmed: [
      {
        twitter: '404',
        logo: TwSvg,
        link: '#'
      },
      {
        instagram: '404',
        logo: IgSvg,
        link: '#'
      },
      {
        youtube: '404',
        logo: YtSvg,
        link: '#'
      },
      {
        facebook: '404',
        logo: FbSvg,
        link: '#'
      }
    ],
    img: chris2x,
    img4x: chris4x
  },
  {
    nameLong: 'Matthew Dombrowski',
    nameShort: 'Matthew Domb.',
    ign: 'Matt',
    joinedDate: 'October 2021',
    games: 'Minesweeper, Skyrim, RDR2, Zelda Breath of the Wild',
    position: TAB.ENGINEERS,
    role: 'Funny Guy',
    description: `Treat cats nicer than humans. climb mountains. follow your dreams and HODL`,
    socmed: [
      {
        twitter: '404',
        logo: TwSvg,
        link: '#'
      },
      {
        instagram: '404',
        logo: IgSvg,
        link: '#'
      },
      {
        youtube: '404',
        logo: YtSvg,
        link: '#'
      },
      {
        facebook: '404',
        logo: FbSvg,
        link: '#'
      }
    ],
    img: matt2x,
    img4x: matt4x
  }
]
